import { useBodyScrollLock } from '@shared/hooks/useBodyScrollLock';

/**
 * @deprecated Use `useBodyScrollLock` from `@shared/hooks/useBodyScrollLock` directly.
 */
export const useTourBodyScrollLock = (isOpen: boolean): void => {
  useBodyScrollLock(isOpen);
};
